import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { RemoveService, DeleteClientDataRequest } from '../services/remove.service';

@Component({
  selector: 'app-remove-data',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent],
  templateUrl: './remove-data.component.html',
  styleUrl: './remove-data.component.scss'
})
export class RemoveDataComponent implements OnInit {
  email: string = '';
  siteId: string = '';
  isSubmitting: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  showSuccess: boolean = false;
  showError: boolean = false;
  result: { success: boolean; message?: string; error?: string } | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private removeService: RemoveService,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit() {
    // Définir le titre de la page (55 caractères - optimal)
    this.title.setTitle('Confirmation suppression données – pdf-to-word.fr');
    
    // Définir les meta tags SEO (160 caractères - optimal)
    this.meta.updateTag({ name: 'description', content: 'Confirmez la suppression définitive de vos données personnelles sur pdf-to-word.fr. Action irréversible conforme au RGPD pour protéger votre vie privée.' });
    this.meta.updateTag({ name: 'keywords', content: 'confirmation suppression données, effacement définitif RGPD, suppression compte pdf-to-word, protection données personnelles' });
    
    // Meta tags supplémentaires pour le SEO
    this.meta.updateTag({ property: 'og:title', content: 'Confirmation suppression données – pdf-to-word.fr' });
    this.meta.updateTag({ property: 'og:description', content: 'Confirmez la suppression définitive de vos données personnelles sur pdf-to-word.fr. Action irréversible conforme au RGPD pour protéger votre vie privée.' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    // Récupérer les paramètres de l'URL
    this.route.queryParams.subscribe(params => {
      this.email = params['email'] || '';
      this.siteId = params['siteId'] || '';
      
      // Valider les paramètres requis
      if (!this.email) {
        this.setError('Paramètres manquants pour traiter votre demande de suppression.');
        return;
      }
    });
  }

  confirmDeletion() {
    if (!this.email) {
      this.setError('Paramètres manquants pour traiter votre demande de suppression.');
      return;
    }

    this.isSubmitting = true;
    this.clearMessages();

    const deleteData: DeleteClientDataRequest = {
      email: this.email,
      origine: 'WEBSITE'
    };

    console.log('Envoi de la demande de suppression:', deleteData);
    
    this.removeService.deleteClientData(deleteData).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        if (response.success) {
          this.result = {
            success: true,
            message: response.message || 'Vos données ont été supprimées avec succès.'
          };
          this.successMessage = this.result.message || '';
          this.showSuccess = true;
        } else {
          this.result = {
            success: false,
            error: response.message || 'Une erreur est survenue lors de la suppression.'
          };
          this.errorMessage = this.result.error || '';
          this.showError = true;
        }
      },
      error: (error) => {
        this.isSubmitting = false;
        console.error('Deletion error:', error);
        this.setError('Une erreur technique est survenue. Veuillez réessayer plus tard.');
      }
    });
  }

  goToHome() {
    this.router.navigate(['/']);
  }

  private setError(message: string) {
    this.errorMessage = message;
    this.showError = true;
    this.isSubmitting = false;
  }

  private clearMessages() {
    this.showSuccess = false;
    this.showError = false;
    this.successMessage = '';
    this.errorMessage = '';
    this.result = null;
  }

  dismissSuccess() {
    this.showSuccess = false;
    this.successMessage = '';
  }

  dismissError() {
    this.showError = false;
    this.errorMessage = '';
  }
}
